var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('img',{style:({ height: `${_vm.height}px`, width: `${_vm.width}px` }),attrs:{"src":_vm.url,"alt":"Avatar"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }